/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { SimplifiedPropertyType } from '../models/SimplifiedPropertyType';
import { ModelUtils } from '../util/ModelUtils';
import { SimplifiedTypeUtil } from '../util/SimplifiedTypeUtil';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { Schema } from '../../core/models/common/Schema';
import { IOasPropertySchema } from '../../openapi/models/IOasPropertySchema';
import { OasSchema } from '../../openapi/models/OasSchema';

/**
 * A command used to create a new schema property.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class NewSchemaPropertyCommand extends AbstractCommand {
    public _propertyName : string;

    public _schemaPath : NodePath;

    public _description : string;

    public _newType : SimplifiedPropertyType;

    public _created : boolean;

    public _nullRequired : boolean;

    public constructor(schema? : any, propertyName? : any, description? : any, newType? : any) {
        if(((schema != null && schema instanceof <any>Schema) || schema === null) && ((typeof propertyName === 'string') || propertyName === null) && ((typeof description === 'string') || description === null) && ((newType != null && newType instanceof <any>SimplifiedPropertyType) || newType === null)) {
            let __args = arguments;
            super();
            if(this._propertyName===undefined) this._propertyName = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._description===undefined) this._description = null;
            if(this._newType===undefined) this._newType = null;
            if(this._created===undefined) this._created = false;
            if(this._nullRequired===undefined) this._nullRequired = false;
            if(this._propertyName===undefined) this._propertyName = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._description===undefined) this._description = null;
            if(this._newType===undefined) this._newType = null;
            if(this._created===undefined) this._created = false;
            if(this._nullRequired===undefined) this._nullRequired = false;
            (() => {
                this._schemaPath = Library.createNodePath(schema);
                this._propertyName = propertyName;
                this._description = description;
                this._newType = newType;
            })();
        } else if(schema === undefined && propertyName === undefined && description === undefined && newType === undefined) {
            let __args = arguments;
            super();
            if(this._propertyName===undefined) this._propertyName = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._description===undefined) this._description = null;
            if(this._newType===undefined) this._newType = null;
            if(this._created===undefined) this._created = false;
            if(this._nullRequired===undefined) this._nullRequired = false;
            if(this._propertyName===undefined) this._propertyName = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._description===undefined) this._description = null;
            if(this._newType===undefined) this._newType = null;
            if(this._created===undefined) this._created = false;
            if(this._nullRequired===undefined) this._nullRequired = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewSchemaPropertyCommand] Executing.");
        this._created = false;
        let schema : OasSchema = <OasSchema>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            LoggerCompat.info("[NewSchemaPropertyCommand] Schema is null.");
            return;
        }
        if(ModelUtils.isDefined(schema.getProperty(this._propertyName))) {
            LoggerCompat.info("[NewSchemaPropertyCommand] Property already exists.");
            return;
        }
        let property : OasSchema = schema.createPropertySchema(this._propertyName);
        if(ModelUtils.isDefined(this._description)) {
            property.description = this._description;
        }
        if(ModelUtils.isDefined(this._newType)) {
            this._setPropertyType(<IOasPropertySchema><any>property);
        }
        schema.addProperty(this._propertyName, property);
        LoggerCompat.info("[NewSchemaPropertyCommand] Property [%s] created successfully.", this._propertyName);
        this._created = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewSchemaPropertyCommand] Reverting.");
        if(!this._created) {
            return;
        }
        let schema : OasSchema = <OasSchema>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            return;
        }
        if(this.isNullOrUndefined(schema.getProperty(this._propertyName))) {
            return;
        }
        schema.removeProperty(this._propertyName);
        if(ModelUtils.isDefined(this._newType) && this._newType.required === true) {
            let required : Array<string> = schema.required;
            /* remove */required.splice(required.indexOf(this._propertyName), 1)[0];
        }
    }

    /**
     * Sets the property type.
     * @param {*} prop
     */
    _setPropertyType(prop : IOasPropertySchema) {
        SimplifiedTypeUtil.setSimplifiedType(<OasSchema><any>prop, this._newType);
        if(ModelUtils.isDefined(this._newType) && this._newType.required === true) {
            let parent : OasSchema = <OasSchema>(<Node><any>prop).parent();
            let required : Array<string> = parent.required;
            if(this.isNullOrUndefined(required)) {
                required = <any>([]);
                NodeCompat.setProperty(parent, Constants.PROP_REQUIRED, required);
                this._nullRequired = true;
            }
            /* add */(required.push(prop.getPropertyName())>0);
        }
    }
}
NewSchemaPropertyCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewSchemaPropertyCommand";
NewSchemaPropertyCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




